module.exports = __webpack_public_path__ + "img/concat.acc52b5e.png";